import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { cn } from "@/lib/utils";
import { NumberInput } from "./NumberInput";

/**
 * Right-hand controls for a scoring factor card: an on/off toggle stacked
 * directly above the Scoring Weight field, aligned with the card header.
 */
export function FactorControls({
  id,
  enabled,
  onEnabledChange,
  value,
  onValueChange,
  step = 1,
}: {
  id: string;
  enabled: boolean;
  onEnabledChange: (v: boolean) => void;
  value: number;
  onValueChange: (v: number) => void;
  step?: number;
}) {
  return (
    <div className="flex flex-col items-end gap-4 shrink-0">
      <div className="flex items-center gap-2">
        <Label htmlFor={id} className="text-sm text-muted-foreground cursor-pointer">
          {enabled ? "On" : "Off"}
        </Label>
        <Switch id={id} checked={enabled} onCheckedChange={onEnabledChange} />
      </div>
      <div className={cn("flex items-center gap-2", !enabled && "opacity-50 pointer-events-none")}>
        <Label className="text-sm text-foreground">Scoring Weight:</Label>
        <NumberInput
          value={value}
          onValueChange={onValueChange}
          min={0}
          max={100}
          step={step}
          disabled={!enabled}
          className="w-20 h-8 text-sm text-center rounded-md bg-card tabular-nums"
        />
        <span className="text-sm text-muted-foreground">%</span>
      </div>
    </div>
  );
}
